import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class CareGap {
  constructor(init) {
    // console.log('> CareGap constructor -', init)
    if (isNil(init)) return undefined
    this._description = init.description
    this._enabled = init.enabled
    this._title = init.title
    this._url = init.url
  }

  static shape = {
    description: PropTypes.string,
    enabled: PropTypes.bool,
    title: PropTypes.string,
    url: PropTypes.string
  }

  get description() {
    return this._description || ''
  }

  get enabled() {
    return !!this._enabled
  }

  get title() {
    return this._title || ''
  }

  get url() {
    return this._url || ''
  }
}

export default CareGap
